export var NSBNAuth;
(function (NSBNAuth) {
    var BNRole;
    (function (BNRole) {
        BNRole["User"] = "User";
        BNRole["Admin"] = "Admin";
    })(BNRole = NSBNAuth.BNRole || (NSBNAuth.BNRole = {}));
})(NSBNAuth || (NSBNAuth = {}));
//# sourceMappingURL=auth.js.map